class VgRelatedProducts extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded === 'true' || this.querySelector('[data-vg-related-content]')) return;
    this.observer?.disconnect();
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.observer.disconnect();
          this.load();
        }
      }, { rootMargin: '400px 0px' });
      this.observer.observe(this);
    } else {
      this.load();
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.request?.abort();
    this.request = null;
  }

  async load() {
    if (this.request || this.dataset.loaded === 'true' || !this.isConnected) return;
    const request = new AbortController();
    this.request = request;
    const timeout = setTimeout(() => request.abort(), 12000);
    try {
      const url = new URL(this.dataset.url, window.location.origin);
      if (url.origin !== window.location.origin) return;
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url, { signal: request.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (request.signal.aborted || this.request !== request || !this.isConnected) return;
      const source = Array.from(html.querySelectorAll('vg-related-products')).find((node) => node.dataset.sectionId === this.dataset.sectionId);
      const content = source?.querySelector('[data-vg-related-content]');
      if (content?.querySelector('[data-vg-related-card]')) this.replaceChildren(content);
      this.dataset.loaded = 'true';
    } catch {
    } finally {
      clearTimeout(timeout);
      if (this.request === request) this.request = null;
    }
  }
}

if (!customElements.get('vg-related-products')) customElements.define('vg-related-products', VgRelatedProducts);
